import circlesIcon from "/public/images/landing/concerns/circles.svg";
import graphBarsIcon from "/public/images/landing/concerns/graph_bars.svg";
import ellipsesIcon from "/public/images/landing/concerns/ellipses.svg";

export const concerns = [
  {
    icon: circlesIcon,
    desc: (
      <>
        기업에서는 자격증보다 실무 지식과 경험을 선호한다는데,{" "}
        <b>어떻게 마케팅 직무 경험을 쌓아야 할지 막막해요.</b>
      </>
    ),
    marketerType: "취업준비생",
  },
  {
    icon: graphBarsIcon,
    desc: (
      <>
        제가 집행한 마케팅이 비즈니스에 어떤 영향을 미쳤는지 파악하기 어려워요.{" "}
        <b>제 능력과 성과를 효과적으로 설명하고 싶어요.</b>
      </>
    ),
    marketerType: "주니어 마케터",
  },
  {
    icon: ellipsesIcon,
    desc: (
      <>
        마케터로의 커리어 전환, 무엇을 준비해야 할지 모르겠어요.{" "}
        <b>지금의 경험을 살리면서 마케팅으로 범위를 확장하고 싶어요.</b>
      </>
    ),
    marketerType: "이직을 희망하는 직장인",
  },
];
